import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { DataService } from '../../data.service';

/**
 *  MINŐSÍTHETŐSÉG A MULASZTÁS MIATT  ·  20/2012. EMMI r. 51. § (7)–(8)
 *
 *  Az osztályfőnök évközben lássa, kinél közelít a mulasztás a határhoz – ne a bizonyítvány
 *  generálásakor derüljön ki, hogy egy tanuló nem minősíthető:
 *    – összes mulasztás: 200 óra fölött figyelmeztetés, 250 fölött „nem minősíthető”;
 *    – tantárgyanként: 25% fölött figyelmeztetés, 30% fölött „nem minősíthető – osztályozó vizsga”;
 *    – igazolatlan: 20 óra fölött „az osztályozó vizsga megtagadható” (51. § (8)).
 *  A számítás a kiszolgálóé (backend/mulasztas-arany.js) – ugyanaz, mint a napló névsoráé és a
 *  bizonyítványé. Itt jelölhető az osztályozó vizsgára kötelezettség is (tanuló + tantárgy, vagy a
 *  250 óra miatt minden tantárgy; félév / év vége); a jelölés a bizonyítvány határozat-
 *  javaslatában is megjelenik.
 *
 *  GYORSJELÖLÉS (2026-11-01): a piros (250 óra fölötti, illetve 30% fölötti tantárgyú) sor fejlécében
 *  okonként egy „Osztályozó vizsgára jelölöm” gomb – a meglévő jelölő végpontot hívja a kiszolgáló
 *  által javasolt értékelési időszakkal (félév vége előtt félévi, utána év végi; 51. § (8) utolsó
 *  mondata); ha már jelölt, ugyanott visszavonható. A 20 igazolatlan óra feletti „megtagadható”
 *  jelzés mellett az 51. § (8) második feltétele: a (3) bekezdés szerinti szülői értesítés rögzítve
 *  van-e (mulasztas_ertesites) – a kiszolgáló `szuloi_ertesites` mezője.
 */

export interface MinTantargy {
  tantargy_id: string; tantargy: string; megtartott: number; mulasztott: number; igazolatlan: number;
  tervezett: number; arany: number; szazalek: number; szint: string;
}
export interface MinJeloles {
  id: string; tantargy: string; tantargy_nev: string; idoszak: 'felev' | 'ev_vege'; ok: string;
  megjegyzes: string | null; jelolte: string | null; jelolve: string | null; szoveg: string;
}
export interface MinSzuloiErtesites {
  kotelezo: boolean; esedekes: boolean; kuszob: number | null; rogzitve: boolean; datum: string | null;
  modja: string | null; kiado: string | null; jogalap: string; szoveg: string;
}
/** Egy gyorsjelölési ok a sor fejlécében: '' = minden tantárgy (250 óra), különben a tantárgy. */
export interface MinGyorsOk { tantargy: string; nev: string; ok: 'osszes_250' | 'tantargy_30'; jeloles: MinJeloles | null; }
export interface MinTanulo {
  oktazon: string; nev: string; kilepett: string | null;
  osszes: number; igazolt: number; igazolatlan: number; elbiralatlan: number; keses_ora: number;
  kockazat: {
    osszes_nem_minositheto: boolean; osszes_figyel: boolean; igazolatlan_megtagadhato: boolean;
    tantargy_nem_minositheto: string[]; tantargy_figyel: string[];
    megtagadhato_ertesites_teljesul?: boolean; igazolatlan_megtagadhato_teljes?: boolean;
  };
  tantargyak: MinTantargy[];
  jelolesek: MinJeloles[];
  szuloi_ertesites?: MinSzuloiErtesites | null;
  /** A felület számolja betöltéskor (gyorsOkSzamol). */
  gyors?: MinGyorsOk[];
}
interface MinHatar { OSSZES: number; OSSZES_FIGYEL: number; ARANY: number; ARANY_NARANCS: number;
  ARANY_SARGA: number; IGAZOLATLAN: number; MIN_ORA: number; }

@Component({
  selector: 'app-of-minosithetoseg',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './of-minosithetoseg.component.html',
  styleUrls: ['./of-minosithetoseg.component.scss'],
})
export class OfMinosithetosegComponent implements OnChanges {
  @Input() intezmeny = '';
  @Input() osztaly = '';
  @Input() tanev: number | null = null;
  @Input() username = '';

  tanulok: MinTanulo[] = [];
  hatar: MinHatar | null = null;
  vonatkozas = '';
  betolt = false;
  hiba = '';
  csakKockazat = true;
  nyitott: string | null = null;
  //  A jelölő űrlap (a kinyitott tanulónál).
  uj: { tantargy: string; idoszak: 'felev' | 'ev_vege'; megjegyzes: string } =
    { tantargy: '', idoszak: 'ev_vege', megjegyzes: '' };
  mentes = false;
  /** A gyorsjelölés értékelési időszaka – a kiszolgáló javaslata (félév vége előtt: félévi). */
  javasoltIdoszak: 'felev' | 'ev_vege' = 'ev_vege';

  constructor(private http: HttpClient, private data: DataService) {}

  ngOnChanges(): void { this.betoltes(); }

  private get intPath(): string { return encodeURI(this.intezmeny); }

  betoltes(): void {
    if (!this.intezmeny || !this.osztaly) { this.tanulok = []; return; }
    this.betolt = true;
    this.hiba = '';
    const p = new URLSearchParams({ osztaly: this.osztaly });
    if (this.tanev) p.set('tanev', String(this.tanev));
    if (this.username) p.set('username', this.username);
    this.http.get<any>(`/api/of/minosithetoseg/${this.intPath}?${p.toString()}`).subscribe({
      next: (r) => {
        this.javasoltIdoszak = r?.javasolt_idoszak === 'felev' ? 'felev' : 'ev_vege';
        this.tanulok = (Array.isArray(r?.tanulok) ? r.tanulok : []).map((t: MinTanulo) => ({ ...t, gyors: this.gyorsOkSzamol(t) }));
        this.hatar = r?.hatar || null;
        this.vonatkozas = String(r?.vonatkozas || '');
        this.betolt = false;
      },
      error: (e) => {
        this.tanulok = [];
        this.betolt = false;
        this.hiba = e?.error?.error || 'Nem sikerült kiszámolni a minősíthetőségi kockázatot.';
      },
    });
  }

  /** Van-e a tanulónál bármi, amiről az osztályfőnöknek tudnia kell. */
  kockazatos(t: MinTanulo): boolean {
    const k = t.kockazat;
    return !!(k?.osszes_figyel || k?.igazolatlan_megtagadhato || k?.tantargy_nem_minositheto?.length
      || k?.tantargy_figyel?.length || t.jelolesek?.length);
  }

  get lathatoTanulok(): MinTanulo[] {
    return this.csakKockazat ? this.tanulok.filter((t) => this.kockazatos(t)) : this.tanulok;
  }

  get kockazatosDb(): number { return this.tanulok.filter((t) => this.kockazatos(t)).length; }

  /** A névsorban mutatott tantárgyak: 20%-tól (a napló sárga jelzésétől), kevés óra nélkül. */
  jelzettTargyak(t: MinTanulo): MinTantargy[] {
    return (t.tantargyak || []).filter((x) => ['sarga', 'narancs', 'piros'].includes(x.szint));
  }

  nemMinositheto(t: MinTanulo, x: MinTantargy): boolean {
    return (t.kockazat?.tantargy_nem_minositheto || []).includes(x.tantargy_id);
  }

  targyCimke(t: MinTanulo, x: MinTantargy): string {
    if (this.nemMinositheto(t, x)) return 'nem minősíthető – osztályozó vizsga';
    if ((t.kockazat?.tantargy_figyel || []).includes(x.tantargy_id)) return 'figyelmeztetés';
    if (x.szint === 'piros') return 'a 30%-os határon';
    return '';
  }

  targyCim(x: MinTantargy): string {
    const sor = [`${x.tantargy}: ${x.mulasztott}/${x.megtartott} óra mulasztás (${x.szazalek}%) – a 30%-os határ: 20/2012. EMMI r. 51. § (7) f)`];
    if (x.igazolatlan) sor.push(`ebből igazolatlan: ${x.igazolatlan} óra`);
    if (x.tervezett > x.megtartott) sor.push(`a tanév ${x.tervezett} órarendi órájának 30%-a: ${this.harmincSzazalek(x)} óra`);
    return sor.join('\n');
  }

  /** Ennyi óra a 30% a tanév órarendi óráiból (e fölött nem minősíthető). */
  harmincSzazalek(x: MinTantargy): number { return Math.floor((x.tervezett || 0) * 0.3); }

  osszesSzint(t: MinTanulo): 'piros' | 'narancs' | '' {
    if (t.kockazat?.osszes_nem_minositheto) return 'piros';
    if (t.kockazat?.osszes_figyel) return 'narancs';
    return '';
  }

  nyit(t: MinTanulo): void {
    this.nyitott = this.nyitott === t.oktazon ? null : t.oktazon;
    //  Alapból a legrosszabb, még nem jelölt tantárgy (vagy a 250 óra miatt mind).
    const jeloltek = new Set((t.jelolesek || []).map((j) => j.tantargy));
    const elso = (t.kockazat?.tantargy_nem_minositheto || []).find((id) => !jeloltek.has(id));
    this.uj = { tantargy: t.kockazat?.osszes_nem_minositheto && !jeloltek.has('') ? '' : (elso || ''),
      idoszak: 'ev_vege', megjegyzes: '' };
  }

  jelol(t: MinTanulo): void {
    if (this.mentes) return;
    this.mentes = true;
    const ok = this.uj.tantargy ? 'tantargy_30' : 'osszes_250';
    this.http.post<any>(`/api/of/osztalyozo-vizsga/${this.intPath}`, {
      osztaly: this.osztaly, tanev: this.tanev, oktazon: t.oktazon, tantargy: this.uj.tantargy,
      idoszak: this.uj.idoszak, ok, megjegyzes: this.uj.megjegyzes, username: this.username,
    }).subscribe({
      next: (r) => {
        this.mentes = false;
        this.data.sendToast(r?.mar_volt ? 'Ez a jelölés már megvolt.' : 'Osztályozó vizsga jelölve.', r?.mar_volt ? 'info' : 'success');
        this.betoltes();
      },
      error: (e) => {
        this.mentes = false;
        this.data.sendToast(e?.error?.error || 'Nem sikerült rögzíteni a jelölést.', 'error');
      },
    });
  }

  /** A piros sor okai a gyorsgombhoz (250 óra → minden tantárgy; 30% fölötti tantárgyak), a meglévő jelöléssel. */
  gyorsOkSzamol(t: MinTanulo): MinGyorsOk[] {
    const ki: MinGyorsOk[] = [];
    const jelolt = (tk: string) => (t.jelolesek || []).find((j) => j.tantargy === tk && j.idoszak === this.javasoltIdoszak)
      || (t.jelolesek || []).find((j) => j.tantargy === tk) || null;
    if (t.kockazat?.osszes_nem_minositheto) ki.push({ tantargy: '', nev: 'minden tantárgy (250 óra)', ok: 'osszes_250', jeloles: jelolt('') });
    for (const id of t.kockazat?.tantargy_nem_minositheto || []) {
      const x = (t.tantargyak || []).find((y) => y.tantargy_id === id);
      ki.push({ tantargy: id, nev: x?.tantargy || 'tantárgy', ok: 'tantargy_30', jeloles: jelolt(id) });
    }
    return ki;
  }

  /** Gyorsjelölés a sor fejlécéből – a javasolt időszakkal, megjegyzés nélkül. */
  gyorsJelol(t: MinTanulo, g: MinGyorsOk): void {
    if (this.mentes) return;
    if (g.jeloles) { this.visszavon(g.jeloles); return; }
    this.mentes = true;
    this.http.post<any>(`/api/of/osztalyozo-vizsga/${this.intPath}`, {
      osztaly: this.osztaly, tanev: this.tanev, oktazon: t.oktazon, tantargy: g.tantargy,
      idoszak: this.javasoltIdoszak, ok: g.ok, megjegyzes: '', username: this.username,
    }).subscribe({
      next: (r) => {
        this.mentes = false;
        this.data.sendToast(r?.mar_volt ? 'Ez a jelölés már megvolt.' : `Osztályozó vizsga jelölve (${this.idoszakNev(this.javasoltIdoszak)}).`,
          r?.mar_volt ? 'info' : 'success');
        this.betoltes();
      },
      error: (e) => {
        this.mentes = false;
        this.data.sendToast(e?.error?.error || 'Nem sikerült rögzíteni a jelölést.', 'error');
      },
    });
  }

  idoszakNev(i: string): string { return i === 'felev' ? 'félévi' : 'év végi'; }

  /** Az 51. § (8) értesítési feltételének rövid címkéje. */
  ertesitesCimke(se: MinSzuloiErtesites): string {
    if (!se.kotelezo) return 'szülői értesítés nem kötelező (nagykorú)';
    return se.rogzitve ? `szülő értesítve ${this.pontos(se.datum)}` : 'szülői értesítés nincs rögzítve';
  }

  visszavon(j: MinJeloles): void {
    if (this.mentes) return;
    this.mentes = true;
    const p = new URLSearchParams({ id: j.id });
    if (this.username) p.set('username', this.username);
    this.http.delete<any>(`/api/of/osztalyozo-vizsga/${this.intPath}?${p.toString()}`).subscribe({
      next: () => { this.mentes = false; this.data.sendToast('A jelölés visszavonva.'); this.betoltes(); },
      error: (e) => {
        this.mentes = false;
        this.data.sendToast(e?.error?.error || 'Nem sikerült visszavonni a jelölést.', 'error');
      },
    });
  }

  /** 'YYYY-MM-DD' → 'YYYY.MM.DD.' (nincs 'hu' date pipe). */
  pontos(iso: string | null): string {
    return /^\d{4}-\d{2}-\d{2}/.test(iso || '') ? `${iso!.slice(0, 4)}.${iso!.slice(5, 7)}.${iso!.slice(8, 10)}.` : '';
  }
}
